import React from 'react'
import { Link } from 'react-router-dom'
import Icon from '@/components/Icon'
import { formatDate } from '@/utils/dateUtilities'
import Resx from '@/components/Resx'
import { DataLoader } from '@/components/dataLoader'
import context from '@/context'
import LoadingIndicator from '@/components/LoadingIndicator'
import { TaskActivationButton } from './taskActivationButton'
import { Scrollbar } from '@/components/scrollbar'
import { Name } from '@/components/Name'
import ErrorBoundary from '@/components/ErrorBoundary'

const dataSourceRequest = {
  pageSize: 5,
  filter: {
    logic: 'or',
    filters: [
      { field: 'status', operator: 'eq', value: 0 },
      { field: 'status', operator: 'eq', value: 1 }
    ]
  },
  sort: [
    { field: 'creationTime', dir: 'desc' }
  ]
}

export default class TopBarTaskList extends React.Component {
  render () {
    const { activeTask, onNavigate, activating } = this.props
    return (
      <DataLoader dataSource={() => context.api.taskService.getMyTasks(dataSourceRequest)} render={x =>
        <div className='d-task-list'>
          <ErrorBoundary>
            <div style={{ position: 'relative' }}>
              <Scrollbar heightRelativeToParent='100%'>
                {x.loading
                  ? <LoadingIndicator />
                  : !x.error && x.data.data.map(task => {
                    let taskActiveClass = activeTask && activeTask.id === task.id ? 'task-id task-id' : 'task-id'
                    return (
                      <div key={task.id} className='d-task__row'>
                        <Link className='task-text' to={`/tasks/${task.id}`} onClick={onNavigate}>
                          <div className='task-title'><Name data={task} /></div>
                          <div className='task__bot'>
                            <div className={taskActiveClass}>
                            #<span className='task-id__number'>{task.id}</span>
                            </div>
                            <div className='task-time'>
                              <span className='time-created'>
                                <time>{formatDate(task.creationTime)}</time>
                              </span>
                              {task.dueDate &&
                              <React.Fragment>
                                <span className='time-due'>
                                  [<Icon name='calendar-check' /> <time>{formatDate(task.dueDate)}</time>]
                                </span>
                              </React.Fragment>
                              }
                            </div>
                          </div>
                        </Link>
                        <div className='task__actions'>
                          <Icon name='dots-horizontal-rounded' />
                          <div className='task-action__active'>
                            <TaskActivationButton
                              taskId={task.id}
                              activeTaskId={activeTask && activeTask.id}
                              onActivate={this.props.activateTask}
                              onDeactivate={this.props.deactivateTask}
                              activating={activating}
                              showButton
                            />
                          </div>
                        </div>
                      </div>
                    )
                  })}
              </Scrollbar>
            </div>
          </ErrorBoundary>
          <div className='text-center mb-3 mt-3'>
            <Link className='underline' to='/tasks' onClick={onNavigate}><Resx name='Tasks.TasksTitle' /></Link>
          </div>
        </div>
      } />
    )
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/components/tasks/TopBarTaskList.js